import Application from 'flarum/common/Application';
import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';

// `mount` is `protected` on Application itself - real, JS has no such thing
// at runtime, and extend() hooking a "protected" lifecycle method is a
// normal, sanctioned Flarum pattern, but TypeScript's own KeyOfType<Application,
// Function> helper won't match a protected key from outside the class. This
// exposes just that one method as public instead of widening to `any` - no
// index signature here (an earlier attempt extending Record<string, unknown>
// made `keyof` widen to `string` and lose `mount`'s own specific Function
// type entirely, confirmed directly), extend()'s own `T extends Record<string,
// any>` generic constraint doesn't actually require one.

export const PREFERENCE_KEY = 'champis-theme-large.enabled';
const CLASS_NAME = 'ChampisThemeLarge';

// Sets/clears the class less/forum.less keys its full-width override off
// of. Exported on its own so the settings Switch (addThemeLargeSetting.js)
// can call it immediately on toggle, for instant feedback, the same way
// core's own colorScheme preference applies live via
// Application#setColorScheme rather than waiting for a fresh boot.
export function setThemeLargeClass(enabled) {
  document.documentElement.classList.toggle(CLASS_NAME, enabled);
}

// Hooked onto Application#mount, not called directly from the
// app.initializers callback: app.session is only assigned in boot(), right
// before mount() runs - reading app.session.user any earlier (i.e. directly
// in an initializer, as this used to) throws "Cannot read properties of
// undefined (reading 'user')", which is exactly what surfaced as "champis-
// theme-large n'a pas réussi à s'initialiser" in the browser console.
// Core's own colorScheme preference is safe reading app.session.user
// because it does so from initColorScheme(), itself only called from
// within mount() too.
export default function applyThemeLargeClass() {
  extend(Application.prototype, 'mount', () => {
    setThemeLargeClass(Boolean(app.session.user?.preferences()?.[PREFERENCE_KEY]));
  });
}